import { inject, Injectable } from '@angular/core';
import { ApiDataAccess } from '@softline/core';
import {
  SOFTLINE_API_PRODUCT_ORDER,
  SOFTLINE_API_PRODUCT_ORDERS,
  SOFTLINE_API_PRODUCT_UNFINISHED_ORDERS,
} from '../garage.api';
import { GarageOrder } from '../models/garage-order';
import { OrderPage } from '../models/order-page';

@Injectable()
export class ProductOrderRepository {
  readonly #dataAccess = inject(ApiDataAccess);

  retrieveById(orderId: number): Promise<GarageOrder> {
    return this.#dataAccess.get({
      path: SOFTLINE_API_PRODUCT_ORDER,
      pathParams: { id: orderId },
    });
  }

  retrieve(
    searchString: string | undefined,
    limit: number | undefined,
    offset?: number | undefined,
    onlyOwn?: boolean | undefined
  ): Promise<OrderPage> {
    return this.#dataAccess.get({
      path: SOFTLINE_API_PRODUCT_ORDERS,
      queryParams: { limit, offset, query: searchString, onlyOwn: onlyOwn || undefined },
    });
  }

  create(order: GarageOrder): Promise<GarageOrder> {
    return this.#dataAccess.create(
      {
        path: SOFTLINE_API_PRODUCT_ORDERS,
      },
      order
    );
  }

  update(orderId: number, order: GarageOrder): Promise<GarageOrder> {
    return this.#dataAccess.update(
      {
        path: SOFTLINE_API_PRODUCT_ORDER,
        pathParams: { id: orderId },
      },
      order
    );
  }

  // Not Implemented in backend
  /* delete(id: number): Promise<void> {
    return this.#dataAccess.delete(
      this.createLocation(SOFTLINE_API_PRODUCT_ORDERS, { id })
    );
  }*/

  retrieveByMechanicId(mechanicId: number): Promise<GarageOrder[]> {
    return this.#dataAccess.get({
      path: SOFTLINE_API_PRODUCT_UNFINISHED_ORDERS,
      pathParams: { id: mechanicId },
    });
  }
}
